var _defs, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 200,
    viewBox: "0 0 420 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007c3e;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#222;}.cls-3{fill:#006428;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.58684,50.00977h25.71289l59.99634,149.99023h-24.64233l-14.99878-38.56934h-66.42334l-15,38.56934h-24.64111l59.99634-149.99023ZM338.0844,140.00488l-24.64111-62.13867-24.64111,62.13867h49.28223Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.65984,52.15332c6.64307,0,12.85645,5.35645,12.85645,12.85645,0,7.49756-6.21338,12.85645-12.85645,12.85645s-12.854-5.35889-12.854-12.85645c0-7.5,6.21094-12.85645,12.854-12.85645ZM395.94695,97.15088h21.42822v102.84912h-21.42822v-102.84912Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.48359 179.79276 28.81695 199.99997 89.75725 199.99997 101.42389 179.79276 40.48359 179.79276"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.42381 171.13247 118.09044 150.9252 57.15039 150.9252 45.48375 171.13247 106.42381 171.13247"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.62044 0 .48372 150.92524 12.15036 171.13255 99.28711 20.20726 87.62044 0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.28711 28.86752 115.95378 49.07478 28.81691 200 17.1503 179.79275 104.28711 28.86752"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.28716 98.14955 120.95388 98.14955 179.75698 199.99997 203.0905 199.99997 144.28716 98.14955"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.42379 199.99997 169.75706 199.99997 110.95372 98.14955 87.62044 98.14955 146.42379 199.99997"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "99.28705 118.35675 110.95369 98.1496 87.62041 98.1496 99.28705 118.35675"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.81682 199.99997 52.15009 199.99997 63.81673 179.7927 40.48346 179.7927 28.81682 199.99997"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.15051 150.9252 45.48387 171.13247 68.8169 171.13247 80.48353 150.9252 57.15051 150.9252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b9c2e07c83dd647e33bc40622498198d.svg";
export { ForwardRef as ReactComponent };